<template>
    <form @submit.prevent="searchPatient">
        <div class="d-flex flex-wrap bax-search-patient">
            <div class="bax-search-patient-holder" v-bind:class="{ 'bax-form-error' : searchKeyword.error }">
              <ul class="d-flex w-100">
                  <li>
                      <label for="fname">First Name</label>
                      <vue-input
                      v-model="searchKeyword.firstName"
                      v-on:input="searchKeyword.error = ''"
                      />
                  </li>
                  <li>
                      <label for="lname">Last Name</label>
                      <vue-input
                      v-model="searchKeyword.lastName"
                      v-on:input="searchKeyword.error = ''"
                      />
                  </li>
                  <li>
                      <label for="pid">Patient ID (MRN)</label>
                      <vue-input
                      v-model="searchKeyword.patientId"
                      v-on:input="searchKeyword.error = ''"
                      />
                  </li>
              </ul>
              <p>{{ searchKeyword.error }}</p>
            </div>
            <div class="bax-form-elemnt w-100">
                <vue-button color="primary" type="submit">
                    Search <i class="icon-search"></i>
                </vue-button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'SearchPatient',
    props: {
        searchKeyword: {
            default() {
                return {
                    firstName: '',
                    lastName: '',
                    patientId: '',
                    error: '',
                };
            },
            type: Object,
        },
    },
    methods: {
        searchPatient() {
            this.$emit('onSearch', this.searchKeyword);
        },
    },
};
</script>
